<div class="lang-switcher">
  @for (locale of locales; track locale.code) {
    <button
      class="lang-btn"
      [class.active]="locale.code === current"
      (click)="select(locale.code)">
      <img class="flag-img" [src]="'assets/flags/' + locale.countryCode + '.svg'" [alt]="locale.label">
      <span class="code">{{ locale.code.toUpperCase() }}</span>
    </button>
  }
</div>
